export default __webpack_public_path__ + "static/media/men-1.dfcae0d9.jpg";